var OCS = OCS || {};
OCS.Live = OCS.Live || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
if (!OCS.DateTime) {
    OCS.DateTime = new Date().getTime();
}
OCS.Functions.define_OCSDateTime = function () {
    return new Class({
        Implements: [Options, Events, new Class(OCS.Interfaces.OCSDateTime)],
        class_type: "OCSDateTime",
        class_name: "OCSDateTime",
        time_interval: null,
        options: {
            anchor: false,
            server_to_local_offset: 0,
            offset_tolerance: 50000, // 50 seconds tolerance, before we start accounting for it
            long_time_format: 'YYYY-MM-DD HH:mm:00',
            display_time_format: 'MM-DD-YYYY h:mm A',
            YmdHM_time_format: 'YYYYMMDDHHmm',
            year_format: 'YYYY',
            month_format: 'MM',
            day_format: 'DD',
            hour_format: 'HH',
            animation_step: 60 * 1000, // how many seconds to jump during a frame change (default 1 minute) in milliseconds
            animation_loop_length: 60 * 61 * 1000 * 1, // length of time in milliseconds for the entire animation loop (default 1 hour and 1 minute)  
            duration: 1 * 60 * 60 * 1000, // in milliseconds how many frames to keep track of
            move_current_epoch_time_forward: true,
            current_time_ratio: 1, // 0: start at the beginning, 1: start at the end of time
            time_interval: 20 * 1000, // Move time forward every 20 seconds
            debug: false
        },
        initialize: function (op) {
            if (OCS.Live[this.class_name]) {
                return OCS.Live[this.class_name];
            }

            this.setOptions(op);
            var local_now = this.get_local_epoch_time();
            // Determine the offset if none is set using our reference time that was 
            //      passed in the HTML, if the difference between local and server 
            //      reference is greater than tolerance, set the offset
            if (!this.options.server_to_local_offset) {
                var offset = OCS.DateTime - local_now;
                if (this.options.debug) {
                    console.log(this.class_name + ": Offset:", offset);
                }
                if ((offset * -1) > this.options.offset_tolerance || offset > this.options.offset_tolerance) {
                    console.warn(this.class_name + ": Significant difference in time between local and server detected! ", offset);
                    this.set_server_to_local_offset(offset);
                }
            }
            // Register the events
            this.initialize_events();
            this.start_time_interval();

            OCS.Live[this.class_name] = this;
        },
        initialize_events: function () {

        },
        start_time_interval: function () {
            this.time_interval = setInterval(this.time_update.bind(this), this.options.time_interval);
        },
        stop_time_interval: function () {
            if(this.time_interval) {
                clearInterval(this.time_interval);
                this.time_interval = null;
            }
        },
        set_time_interval: function(time) {
            if(time > 0) {
                this.stop_time_interval();
                this.options.time_interval = time;
                this.start_time_interval();
            }
        },
        destroy: function () {
            this.stop_time_interval();
            delete OCS.Live[this.class_name];
        }
    });
};


